import React, { useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import { Stack } from '@mui/material'
import { useForm } from 'react-hook-form'
import Input from 'components/generic/form/Input'
import DialogModal from '.'

const CreatePriceListModal = ({ open, onSave, priceLists, isUpdate, currentDisplayName, ...restProps }) => {
  const {
    control,
    formState: { errors },
    setError,
    clearErrors,
    getValues,
    reset,
  } = useForm()

  useEffect(() => {
    if (open === true) {
      reset()
    }
  }, [open])

  const handleSaveName = (newPriceListName, pList) => {
    const newPriceListNameTrimmed = newPriceListName.toUpperCase().trim()
    const nameAlreadyExists = () =>
      pList.some(priceList => (priceList.displayName || '').toUpperCase().trim() === newPriceListNameTrimmed)
    if (nameAlreadyExists(newPriceListNameTrimmed, pList)) {
      // Set an error if the name is already used
      setError('priceListName', { type: 'custom', message: 'This name has already been used' })
    } else {
      // Save the new price list name if it's not used
      onSave(newPriceListName)
    }
  }

  return (
    <DialogModal
      open={open}
      {...restProps}
      onSave={() => {
        // Get the new price list name from the form values
        const newPriceListName = getValues('priceListName')
        if (newPriceListName === '') {
          setError('priceListName', { type: 'custom', message: 'This field is required' })
          return
        }

        // Check if we are updating an existing price list
        if (isUpdate) {
          // Check if the new name is different from the current name
          if (newPriceListName.trim() !== currentDisplayName.trim()) {
            // Filter out the current price list
            const filteredList = priceLists.filter(pl => pl.displayName !== currentDisplayName)

            handleSaveName(newPriceListName, filteredList)
          } else {
            // Set an error if the name is the same from the current name
            setError('priceListName', { type: 'custom', message: 'This name has already been used' })
          }
        } else {
          // For a new price list
          handleSaveName(newPriceListName, priceLists)
        }
      }}
    >
      <Stack pt={1}>
        <Input
          name="priceListName"
          label="Price List Name"
          defaultValue=""
          onChange={() => clearErrors()}
          control={control}
          error={!!errors?.priceListName}
          helperText={errors?.priceListName?.message}
        />
      </Stack>
    </DialogModal>
  )
}

CreatePriceListModal.propTypes = {
  ...DialogModal.propTypes,
  open: PropTypes.bool.isRequired,
  onSave: PropTypes.func,
  priceLists: PropTypes.array,
  isUpdate: PropTypes.bool,
  currentDisplayName: PropTypes.string,
}

CreatePriceListModal.defaultProps = {
  ...DialogModal.defaultProps,
  onSave: () => {},
  priceLists: [],
  isUpdate: false,
  currentDisplayName: '',
}

export default CreatePriceListModal
